import { MutableRefObject, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

import { AgGridReact } from '@ag-grid-community/react';

import { BOM_TABLES_ENUM } from "../constants";

// AggridReact gives the following colId to the groupCell, and doesn't use our provided
// colId to name the autoGroupColumn.
export default function useFocusOnSectionCreate<TData>(
    tableRef: MutableRefObject<AgGridReact | null>,
    tableData?: TData[] | null,
    focusDelay?: number,
) {
    const [focusNow, setFocusNow] = useState(false);

    const focusDelayRef = useRef(focusDelay);
    useLayoutEffect(() => {
        focusDelayRef.current = focusDelay;
    }, [focusDelay]);

    const tableDataSize = tableData?.length || 0;
    useEffect(() => {
        if (!focusNow) return;
        const timeout = setTimeout(() => {
            tableRef.current?.api.clearFocusedCell();
            tableRef.current?.api.clearRangeSelection();

            // Somehow Aggrid is not using colId/field defined in autoGroupColumnDef as
            // colId for group column. So using the defaultID defined by it.
            const api = tableRef.current?.api;
            if (api) {
                const lastRowIndex = api.getDisplayedRowCount() - 1;
                if (typeof lastRowIndex === 'number') {
                    api.ensureIndexVisible(lastRowIndex);
                }
                // Here, ensure the view changes before calling`setFocusedCell`.
                setTimeout(() => {
                    api.setFocusedCell(lastRowIndex - 1, BOM_TABLES_ENUM.TYPE);
                }, Math.min(tableDataSize * 5, 1000))

            }
            setFocusNow(false);
        }, focusDelayRef.current);

        return () => {
            clearTimeout(timeout);
        }
    }, [tableData, tableRef, focusNow]);

    const focusOnFirstSectionCell = useCallback(() => {
        // set flag to true, and wait for table data to update before focusing.
        setFocusNow(true);
    }, []);

    return { focusOnFirstSectionCell };
}